Vue.component('quizzes', {
    data () {
        return {
            activeId: null,

            dates: {
                from: '',
                to: ''
            }
        };
    },

    methods: {
        handleFilterDateSelected (field, val) {
            this.dates[field] = val;
        },

        download (id) {
            this.activeId = id;

            $('#export').modal('show');
        }
    },

    computed: {
        exportLink () {
            let link = '/admin/questions/export/' + this.activeId;
            let queries = [];

            for (let date in this.dates) {
                if (this.dates[date].length > 0) {
                    queries.push(date + '=' + this.dates[date]);
                }
            }

            return link + (queries.length > 0 ? '?' + queries.join('&') : '');
        }
    }
});